var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      style: { "z-index": _vm.zIndex || 1050 },
      attrs: { id: "delivery-product-add-modal", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-xl",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                {
                  ref: "deliveryProductModal",
                  staticClass: "panel products-table",
                  staticStyle: { position: "relative" }
                },
                [
                  _c("table-delivery-product-add", {
                    ref: "deliveryProductAddTable",
                    attrs: {
                      url: "/Delivery/product-available",
                      extraUrl: ["Product/get-image-name"],
                      extraUrlMode: true,
                      columns: _vm.deliveryProductColumns,
                      isSearchable: true,
                      needExtraData: true,
                      loadingTableMode: true,
                      clientMode: true,
                      checkedItems: _vm.checkedItems,
                      isShowBtnBulkCreate: true,
                      selectedProducts: _vm.deliverySelectedProducts
                    },
                    on: {
                      countData: function($event) {
                        _vm.countData = $event
                      },
                      extraData: function($event) {
                        _vm.extraData = $event
                      },
                      keyword: _vm.onHandleSearch,
                      zIndex: function($event) {
                        _vm.zIndex = $event
                      },
                      checkBoxAll: _vm.checkBoxAll,
                      bulkAdd: _vm.bulkAddProducts,
                      onHandleReload: _vm.onHandleReload
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "checkBoxAll",
                        fn: function(props) {
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.checkedItems,
                                  expression: "checkedItems"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: props.rowData.asin,
                                checked: Array.isArray(_vm.checkedItems)
                                  ? _vm._i(
                                      _vm.checkedItems,
                                      props.rowData.asin
                                    ) > -1
                                  : _vm.checkedItems
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.checkedItems,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = props.rowData.asin,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.checkedItems = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.checkedItems = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.checkedItems = $$c
                                    }
                                  },
                                  _vm.refreshCheckAll
                                ]
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "status",
                        fn: function(props) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(props.rowData.status_str))
                            ])
                          ]
                        }
                      },
                      {
                        key: "image",
                        fn: function(props) {
                          return [
                            _c(
                              "loading-block",
                              {
                                attrs: {
                                  value: props.rowData.image,
                                  type: "image"
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "product-img",
                                  attrs: {
                                    src: _vm.prepareImgSrc(props.rowData.image)
                                  }
                                })
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "productName",
                        fn: function(props) {
                          return [
                            _c(
                              "loading-block",
                              {
                                attrs: {
                                  value: props.rowData.itemName,
                                  type: "string"
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "text--underline",
                                    attrs: {
                                      href:
                                        "https://www.amazon.co.jp/gp/offer-listing/" +
                                        props.rowData.asin,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(props.rowData.itemName) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "action",
                        fn: function(props) {
                          return [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-warning",
                                on: {
                                  click: function($event) {
                                    _vm.addProduct(props.rowData)
                                  }
                                }
                              },
                              [_vm._v("追加")]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row m-b-sm" }, [
                    _c("div", { staticClass: "flexbox justify-right" }, [
                      _vm.checkedItems.length
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-warning btn-add-checked-all mr-r-10",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.bulkAddProducts()
                                }
                              }
                            },
                            [_vm._v("選択した商品を追加")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          attrs: { "data-dismiss": "modal" },
                          on: {
                            click: function($event) {
                              _vm.$emit("close")
                            }
                          }
                        },
                        [
                          _c(
                            "button",
                            { staticClass: "btn ver-middle w-120" },
                            [_vm._v("閉じる")]
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46e57169", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e57169","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/components/DeliveryProductAdd.vue
// module id = null
// module chunks = 